// Async action
export const ADD_PROJECT_BEGIN = "ADD_PROJECT_BEGIN";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_ERROR = "ADD_PROJECT_ERROR";

export const FETCH_PROJECTS_BEGIN = "FETCH_PROJECTS_BEGIN";
export const FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS";
export const FETCH_PROJECTS_ERROR = "FETCH_PROJECTS_ERROR";

export const AUTH_VERIFY_BEGIN = "AUTH_VERIFY_BEGIN";
export const AUTH_VERIFY_SUCCESS = "AUTH_VERIFY_SUCCESS";
export const AUTH_VERIFY_ERROR = "AUTH_VERIFY_ERROR";

export const SIGNOUT_USER_BEGIN = "SIGNOUT_USER_BEGIN";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const SIGNOUT_USER_ERROR = "SIGNOUT_USER_ERROR";
